<template>
	<section v-if="items.length > 0" class="related">
		<header>
			<p class="eyebrow">You May Be Interested In</p>

			<h2>Similar Jobs</h2>
		</header>

		<div class="inner">
			<template v-for="item of items" :key="item.uuid">
				<job-deck
					v-if="item.variant_preview && item.variant_preview.length > 1"
					:item="item"
					:hide_summary="true"
					:hide_apply_button="true"
					:logo_url_template="logo_url_template"
					:disable_modal="true"
				/>

				<job
					v-else
					:item="item"
					:hide_summary="true"
					:hide_apply_button="true"
					:logo_url_template="logo_url_template"
					:disable_modal="true"
				/>
			</template>
		</div>

		<footer v-if="hub_url">
			<a :href="hub_url" class="btn btn-bordered"> Browse All Jobs </a>
		</footer>
	</section>
</template>

<style lang="scss" scoped>
@use 'sass:math';

@use '/sass/variables' as *;
@use '/sass/toolkit' as *;

.related {
}

header {
	margin-bottom: 1rem;

	.eyebrow {
		margin-bottom: 0;
		color: $orange;
		font-weight: bold;
	}

	h2 {
		@include h4;
	}
}

.inner {
	display: grid;
	// grid-template-columns: repeat(3, 1fr);
	gap: 1rem;
	margin-bottom: 1rem;

	.job-deck {
		margin-bottom: 1em;
	}
}

@include media('<=portrait') {
	.inner {
		// grid-template-columns: repeat(2, 1fr);
	}
}

@include media('<=phone') {
	.inner {
		//grid-template-columns: 1fr;
	}
}

footer {
	display: flex;
	justify-content: center;

	.btn-bordered {
		font-size: 1rem;
	}
}
</style>

<script setup>
import { useFetch } from '@vueuse/core';
import { computed } from 'vue';

import Job from '../jobs-app/_job.vue';
import JobDeck from '../jobs-app/_job-deck.vue';

const props = defineProps({
	api_url: {
		type: String,
		required: true,
	},
	uuid: {
		type: String,
		required: true,
	},
	hub_url: {
		type: String,
		required: true,
	},
	logo_url_template: {
		type: String,
		required: true,
	},
});

const { data } = useFetch(
	`${props.api_url}/api/listings/${props.uuid}/related?grouped=true&limit=5&viewed_company=last`,
	{
		credentials: `same-origin`,
	},
)
	.get()
	.json();

const items = computed(() => (data.value || []).slice(0, 5));
</script>
